import type { Router } from 'vue-router'
import { hasOwnBridge, isApl, isIOS, isInAndroidApp } from '@/env'
import { useSystemInfo, useUserInfo } from '@/store'
import type { iGame, iGameCategory } from '@/types/index'
import bcrypt from 'bcryptjs'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { FINGER_PRINT_KEY, SALT_KEY } from '@/consts'
import dayjs from 'dayjs'
import { handleSaqueClick } from '@/utils/userStatusUtils'
import { reportErrorMessage } from '@/utils/reportError'
import { useClipboard } from '@vueuse/core'
import { showToast } from 'vant'
// import useFromAndTo from "@/hooks/useFromAndTo";

export const lowPriorityAsyncCall = (fn: () => void) => {
  let callFn: (fn: () => void) => void
  if ('requestIdleCallback' in window) {
    callFn = requestIdleCallback
  } else {
    callFn = setTimeout
  }
  callFn(fn)
}

export const wait = (seconds: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, seconds * 1000)
  })
}

export const downloadFile = (url, _fileName) => {
  // const a = document.createElement('a')
  // a.href = url
  // a.target = '_self'
  // a.download = fileName
  // a.click()
  console.log('downloadFile:url', url)
  location.href = url
}

// const isFromDrainageWebsite = () => {
//   const drainageArr = ['facebook', 'instagram']
//   return drainageArr.some((item) => document.referrer.includes(item))
// }

export const launchChrome = (s = location.href) => {
  // if (isChrome) return

  const url = s.replace(/^http(s)?:\/\//, '')

  if (isIOS) {
    location.href = 'googlechrome://' + url
  } else {
    location.href = `intent://${url}#Intent;package=com.android.chrome;scheme=http;end;`
    // window.open(`intent://${url}#Intent;package=com.android.chrome;scheme=http;end;`, '_blank')
  }
}

export const gotoActivity = (item, router: Router, replace = false) => {
  if (replace) {
    router.replace({
      path: item.link,
      query: {
        activityId: item.activityId,
      },
    })
  } else {
    router.push({
      path: item.link,
      query: {
        activityId: item.activityId,
      },
      state: {
        // currentActivity: toRaw(item)
      },
    })
  }
}

export const handleJumpLink = (item, router, replace = false) => {
  if (item.hyperlinkType == 'NONE') return
  // 如果hyperlinkType是 BUILT_IN_LINK=内置链接 的时候，hyperlink 里的值都是路由路径
  // 如果hyperlinkType是 ACTIVITY_PAGE_LINK=活动页链接 的时候，hyperlink 就为活动页的linkName（B端从服务器获取的，其实也是路由路径），activityId里是ActivityID
  // 如果hyperlinkType是 CUSTOM_LINK=自定义链接 的时候，这里需要区分jumpMethod为内跳或者外跳，hyperlink里放的是对应的URL
  if (item.hyperlink) {
    if (item.hyperlinkType === 'CUSTOM_LINK') {
      if (item.jumpMethod === 'EXTERNAL_JUMP') {
        if (isIOS) {
          // iOS Safari 静默处理：尝试多种跳转方式
          const success = openUrlSafely(item.hyperlink)
          if (!success) {
            // 静默重试：延迟后再次尝试直接跳转
            setTimeout(() => {
              try {
                window.location.href = item.hyperlink
              } catch (e) {
                // Silent fail
              }
            }, 1000)
          }
        } else {
          if(isInAndroidApp){
            callJSBridge("openWindow", {url:item.hyperlink});
          }else{
            const newWindow = window.open(item.hyperlink, '_blank')
            // 如果弹窗被阻止，回退方案
            if (!newWindow || newWindow.closed) {
              window.location.href = item.hyperlink
            }
          }

        }
      } else {
        window.location.href = item.hyperlink
      }
    } else {
      if (item.hyperlink === '/saque') {
        // 提款页先展示弹窗
        // updateIsOpenStatus();
        //
        handleSaqueClick(router, null, replace)
      } else {
        gotoActivity(
          {
            activityId: item.activityId,
            link: item.hyperlink,
          },
          router,
          replace,
        )
      }
    }
  }
}

export const gotoGameCategory = (item: iGameCategory, router: Router) => {
  router.push({
    path: '/gamecategory',
    query: {
      cid: item.id,
    },
    state: {
      // @ts-ignore
      currentCategory: toRaw(item),
    },
  })
}

export const gotoGame = (item: iGame, router: Router, list: iGame[]) => {
  if (useUserInfo().isLoggedin) {
    router.push(`/game?gameCode=${item.code}`)
    reportErrorMessage(item, list, {
      page: 'gameLogin',
      reqUrl: `/game/login`,
    })
  } else {
    router.push('/login')
  }
}

export const formatter = (mindigits = 2, maxDigits = 2) => {
  const langStr = useSystemInfo().langStr

  return new Intl.NumberFormat(langStr, {
    style: 'decimal',
    minimumFractionDigits: mindigits,
    maximumFractionDigits: maxDigits,
  })
}

export const copyText = (text: string, skipToast = false) => {
  return navigator.clipboard
    .writeText(text)
    .then(() => {
      console.log('copyText success')
      !skipToast &&
        showSuccessToast({
          message: 'Cópia Bem-sucedida',
          iconSize: 30,
          forbidClick: true,
        })
    })
    .catch((e) => {
      console.log('copyText error', e)
      const { copy } = useClipboard()
      copy(text)
        .then(() => {
          console.log('copyText success2')
          !skipToast &&
            showSuccessToast({
              message: 'Cópia Bem-sucedida',
              iconSize: 30,
              forbidClick: true,
            })
        })
        .catch((e) => {
          console.log('copyText error2', e)
          !skipToast &&
            showFailToast({
              message: 'Cópia falhou',
              iconSize: 30,
              forbidClick: true,
            })
        })
    })
    .finally(() => {
      if (document.activeElement) (document.activeElement as HTMLElement).blur()
    })
}

export const readText = async () => {
  try {
    return await navigator.clipboard.readText()
  } catch (err) {
    console.error('读取剪贴板内容失败:', err)
    throw err
  }
}

//密码加密
export const encryptPassword = (password: string) => {
  return bcrypt.hashSync(password, SALT_KEY)
}

export const cryptoID = (eventName: string) => {
  return eventName + '-' + localStorage.getItem('pwaId')
}

export async function generateFingerprint() {
  if (localStorage.getItem(FINGER_PRINT_KEY)) {
    return localStorage.getItem(FINGER_PRINT_KEY)
  }

  const fp = await FingerprintJS.load()
  const result = await fp.get()
  localStorage.setItem(FINGER_PRINT_KEY, result.visitorId)
  return result.visitorId
}

// 格式化金额
export const formatNumber = (value: number, mindigits = 2, maxDigits = 2) => {
  const number = parseFloat(value as any)

  if (isNaN(number)) {
    return value // 如果不是有效数字，直接返回原值
  }

  if (number >= 1000000) {
    const formattedValue = number / 1000000
    return `${formatter(mindigits, maxDigits).format(formattedValue)}M`
  }

  if (number >= 1000) {
    const formattedValue = number / 1000
    return `${formatter(mindigits, maxDigits).format(formattedValue)}K`
  }

  return formatter(mindigits, maxDigits).format(value)
}

// 1. 前端本地引用 local://live.png 把local://替换成本地图片路径后打开
// 2. OSS存储引用 oss://a/b/live.png 把oss://替换成OSS图片地址后打开
// 3. HTTP直接 http://xxxx.com/a/b/live.png 直接打开图片
export const getImageUrl = (url: string) => {
  const { imageBaseUrl } = useSystemInfo()
  const localPath = `//c.bg52w.com/public/static/images/defaults/`
  return url.replace('local://', localPath).replace('oss://', imageBaseUrl)
}

// 获取日期范围
export const getDateRange = (range: string) => {
  const today = dayjs().tz('America/Sao_Paulo')
  console.log('today', today.valueOf())
  const ranges = {
    Hoje: [today.startOf('day').valueOf(), today.endOf('day').valueOf()],
    Ontem: [
      today.subtract(1, 'day').startOf('day').valueOf(),
      today.subtract(1, 'day').endOf('day').valueOf(),
    ],
    'Esta semana': [
      today.startOf('week').valueOf(),
      today.endOf('week').valueOf(),
    ],
    'Este mês': [
      today.startOf('month').valueOf(),
      today.endOf('month').valueOf(),
    ],
    'Mês passado': [
      today.subtract(1, 'month').startOf('month').valueOf(),
      today.subtract(1, 'month').endOf('month').valueOf(),
    ],
    'Últimos três meses': [
      today.subtract(90, 'day').startOf('day').valueOf(),
      today.endOf('day').valueOf(),
    ],
  }

  return ranges[range] || ranges['Hoje']
}

// 格式化成巴西时间格式
export const formatDateInPortuguese = (dateString) => {
  const months = [
    'jan.',
    'fev.',
    'mar.',
    'abr.',
    'mai.',
    'jun.',
    'jul.',
    'ago.',
    'set.',
    'out.',
    'nov.',
    'dez.',
  ]
  const date = dayjs(dateString)
  const day = date.date()
  const month = months[date.month()]
  const year = date.year()
  const hours = date.hour().toString().padStart(2, '0')
  const minutes = date.minute().toString().padStart(2, '0')
  const seconds = date.second().toString().padStart(2, '0')

  return `${day} de ${month} de ${year} ${hours}:${minutes}:${seconds}`
}

export const useFormattedDate = (dateString) => {
  const formatDateInPortuguese = (date) => {
    const months = [
      'jan.',
      'fev.',
      'mar.',
      'abr.',
      'mai.',
      'jun.',
      'jul.',
      'ago.',
      'set.',
      'out.',
      'nov.',
      'dez.',
    ]
    const day = date.date()
    const month = months[date.month()]
    const year = date.year()

    return `${day} de ${month} de ${year}`
  }

  const date = dayjs(dateString)
  const formattedDate = formatDateInPortuguese(date)

  return formattedDate
}

export const fetchWithLoading = async (
  fn: () => Promise<any>,
  {
    loadingText = 'loading...',
    errorText = 'error',
    successText = '',
    onSuccess = () => {},
  }: {
    loadingText?: string
    errorText?: string
    successText?: string
    onSuccess?: () => void
  } = {},
) => {
  showLoadingToast(loadingText)
  try {
    const res = await fn()
    if (res.code == 1) {
      if (successText) {
        showSuccessToast({
          iconSize: 30,
          message: successText,
          onClose: onSuccess,
        })
      } else {
        closeToast()
      }
    } else {
      showToast(res.msg)
    }
    return res
  } catch (error) {
    showToast(errorText)
  }
}

// 次数
export const formatCount = (v, unit = 'K') => {
  if (v < 1000) {
    return v
  } else {
    return Math.floor(v / 1000) + unit
  }
}

export const callJSBridge = (eventName, params = {}) => {
  // console.log('callJSBridge', eventName, params)
  window.jsBridge?.postMessage(eventName, JSON.stringify(params))
}

export const createObjfromStr = (str: string) => {
  const obj = {}
  const arr = str.split('&')
  arr.forEach((item) => {
    const [key, value] = item.split('=')
    obj[key] = value
  })
  return obj
}

export const getAuthStr = (userInfo) => {
  let s = ''
  try {
    if (userInfo && userInfo.token) {
      const lUserInfo = getUserNameAndPassword()
      let url = `token=${userInfo.token}`
      if (lUserInfo.username && lUserInfo.password) {
        url = `${url}&un_flag=${lUserInfo.username}&ps_flag=${lUserInfo.password}`
      }
      s = 'info=' + btoa(encodeURIComponent(url))
      if (s === 'info=null') {
        s = ''
      }
    }
  } catch (e) {
    console.error('getAuthStr', e)
  }
  return s
}

export const back = (router: Router) => {
  // if (useFromAndTo().fromRoute.value?.path) {
  //   return
  // }
  router.back()
}

export const formatNumberAsMoney = (num: string) => {
  const parts = num.split(',')
  if (parts.length > 1 && Number(parts[1]) > 0) {
    return num.endsWith('0') ? num.slice(0, -1) : num
  } else {
    return parts[0]
  }
}

// 保存登录使用的用户名密码
export const saveUserNameAndPassword = (
  username: string | null | undefined,
  password: string | null | undefined,
  isAutoLogin = false,
) => {
  if (!username || !password) {
    return
  }
  //自动登录时，判断当前是否已经有保存用户名密码，没有的话再去保存，如果有的话就不要覆盖手动登录的用户名密码了
  if (isAutoLogin) {
    console.log('自动登录时，判断当前是否已经有保存用户名密码')
    const lUserInfo = getUserNameAndPassword()
    if (lUserInfo.username && lUserInfo.password) {
      console.log('自动登录时，已经有保存的用户名密码了，就不再保存了')
      return
    }
  }
  // 在自有安卓包,通过JSBridge保存账号密码，否则直接保存到localStorage
  if (hasOwnBridge) {
    console.log('在自有安卓包,准备调用这个,保存账号密码的接口')
    console.log('isApl', isApl)
    const params2 = new URLSearchParams(location.search)
    console.log('params2', params2)
    window.jsBridge.postMessage(
      'setUserInfo',
      JSON.stringify({ username, password }),
    )
  } else {
    localStorage.setItem('un_flag', username)
    localStorage.setItem('ps_flag', password)
    console.log('保存好了，测试取一下')
    console.log('getUserNameAndPassword-->lUserInfo', getUserNameAndPassword())
  }
}

// 获取登录使用的用户名密码
export const getUserNameAndPassword = () => {
  let lUserInfo: { username: string; password: string } = {
    username: '',
    password: '',
  }
  if (hasOwnBridge) {
    //从JSBridge读取
    const res = window.jsBridge.postMessage('getUserInfo', '')
    console.log('在自有安卓包,取得的用户名密码:', res)
    //兼容老版本APK，有可能这里获取出来是ok
    if (
      res === 'ok' ||
      res === '' ||
      res === 'undefined' ||
      res === null ||
      res === undefined
    ) {
      return { username: '', password: '' }
    }
    const r = JSON.parse(res)
    lUserInfo.username = r.username
    lUserInfo.password = r.password
  } else {
    if (localStorage.getItem('un_flag') && localStorage.getItem('ps_flag')) {
      lUserInfo.username = localStorage.getItem('un_flag') || ''
      lUserInfo.password = localStorage.getItem('ps_flag') || ''
    }
  }
  console.log('getUserNameAndPassword-->lUserInfo', lUserInfo)
  return lUserInfo
}

//这个功能暂时不用
export const clearUserNameAndPassword = () => {
  // localStorage.removeItem('un_flag')
  // localStorage.removeItem('ps_flag')
  // if (isInAndroidApp) {
  //   window.jsBridge.postMessage("clearUserInfo", "");
  // }
}

// 获取 CSS 变量值的方法
export const getCssVar = (name: string) => {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim()
}

// 将 rem 转换为 px
export const remToPx = (rem: string) => {
  return (
    parseFloat(rem) *
    parseFloat(getComputedStyle(document.documentElement).fontSize)
  )
}

export const loadScript = (url: string) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = url
    script.async = true
    script.onload = () => {
      resolve(true)
    }
    script.onerror = () => {
      reject(new Error(`Failed to load script: ${url}`))
    }
    document.head.appendChild(script)
  })
}

function openUrlSafely(url, target = '_blank') {
  // iOS Safari specific handling
  if (isIOS) {
    // Check if we're in a user gesture context (iOS Safari requirement)
    const isUserGesture =
      document.visibilityState === 'visible' && !document.hidden

    if (!isUserGesture) {
      // If not in user gesture context, try the most reliable method first
      try {
        const link = document.createElement('a')
        link.href = url
        link.target = target
        link.rel = 'noopener noreferrer'
        link.style.display = 'none'

        document.body.appendChild(link)
        link.click()

        setTimeout(() => {
          document.body.removeChild(link)
        }, 100)

        return true
      } catch (e) {
        // Silent fail
      }
    }

    // Method 1: Try using window.open with user gesture
    try {
      const newWindow = window.open(url, target)
      if (newWindow && !newWindow.closed) {
        return true
      }
    } catch (e) {
      // Silent fail
    }

    // Method 2: Try using location.href (iOS Safari allows this in some cases)
    try {
      window.location.href = url
      return true
    } catch (e) {
      // Silent fail
    }

    // Method 3: Create and click a link element (most reliable for iOS)
    try {
      const link = document.createElement('a')
      link.href = url
      link.target = target
      link.rel = 'noopener noreferrer'
      link.style.display = 'none'

      // Add to DOM temporarily
      document.body.appendChild(link)

      // Trigger click
      link.click()

      // Clean up
      setTimeout(() => {
        document.body.removeChild(link)
      }, 100)

      return true
    } catch (e) {
      // Silent fail
    }

    // Method 4: Final fallback - try to open in same window
    try {
      window.location.href = url
      return true
    } catch (e) {
      return false
    }
  } else {
    // Non-iOS devices - use original logic
    // 1. 先尝试标准 window.open
    const newWindow = window.open('', target)

    if (newWindow) {
      try {
        // 避免跨域限制的特殊写法
        newWindow.location.href = url
        return true
      } catch (e) {
        newWindow.close()
      }
    }

    // 2. 尝试动态创建a标签
    const link = document.createElement('a')
    link.href = url
    link.target = target
    link.rel = 'noopener noreferrer'
    link.style.display = 'none'

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    // 3. 设置超时检测，如果前两种方法都失败则回退
    setTimeout(() => {
      if (!newWindow || newWindow.closed) {
        window.location.href = url // 最终回退方案
      }
    }, 150) // 150ms是经验值，足够检测是否跳转成功
  }
}
